// Scrolls to the first visibly-invalid element on the page. Runs two rAF ticks after
// the SHOW_ERRORS dispatch so the error outlines are rendered before we query them.
// [data-error-anchor] is the opt-in hook for error spots that are not MUI form fields
// (e.g. the AGB consent checkbox row).
// The payment step keeps its desktop bottom box mounted with display:none on small
// viewports and renders the same controls again in the visible sidebar, so the first
// DOM match can be an invisible duplicate — skip candidates in display:none subtrees.
const isInDisplayNoneSubtree = (el) => {
    for (let node = el; node; node = node.parentElement) {
        if (window.getComputedStyle(node).display === 'none') {
            return true;
        }
    }
    return false;
};

const scrollToFirstError = () => {
    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
            const errorEl = Array.from(document.querySelectorAll('.Mui-error, [data-error-anchor]')).find(
                (el) => !isInDisplayNoneSubtree(el),
            );
            if (!errorEl) {
                return;
            }
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Prefer [role="combobox"]: MUI Select's interactive target is a focusable div;
            // its underlying <input> is hidden and useless to keyboard/screen-reader users.
            const focusable =
                errorEl.closest('.MuiFormControl-root')?.querySelector('[role="combobox"], input, textarea') ||
                errorEl.querySelector('[role="combobox"], input, textarea');
            focusable?.focus({ preventScroll: true });
        });
    });
};

// Shared continue-button guard: navigate/submit only when the step is valid,
// otherwise reveal all invalid fields and jump to the first one.
const proceedOrShowErrors = ({ validationErrors, showValidationErrors, proceed }) => {
    if (!validationErrors) {
        proceed();
        return;
    }
    showValidationErrors(validationErrors);
    scrollToFirstError();
};

export { scrollToFirstError, proceedOrShowErrors };
